module.exports = __webpack_public_path__ + "img/team-norderstedt.4dcef0de.jpg";